import {
  DestroyRef,
  Directive,
  ElementRef,
  NgZone,
  inject,
  output,
} from "@angular/core";

// Emits once, the first time the host scrolls into the viewport - for work
// that is wasted on content nobody looks at. The observer callback runs outside
// NgZone, hence the re-entry.
@Directive({
  selector: "[appInViewport]",
})
export class InViewportDirective {
  public readonly appInViewport = output<void>();

  constructor() {
    const ngZone = inject(NgZone);
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect();
        ngZone.run(() => this.appInViewport.emit());
      }
    });
    observer.observe(inject(ElementRef<HTMLElement>).nativeElement);
    inject(DestroyRef).onDestroy(() => observer.disconnect());
  }
}
